import { Fragment } from 'react';

import css from 'styles/components/common/starRatingRadio.scss';

/*
  `starRatings` must be from highest to lowest for the CSS highlighting to work.

  Note: there are XBrowser bugs with fieldset & flexbox which is why I went with div[role='group']
  https://stackoverflow.com/questions/28078681/why-cant-fieldset-be-flex-containers
*/

const StarRatingRadio = ({ starRatings, name, indexId, required, onChange }) => (
  <div role="group" className={css.container}>
    {starRatings.map(v => {
      const key = `${name}-star${v}`;
      return (
        <Fragment key={key}>
          <input
            type="radio"
            id={key}
            name={name}
            value={v}
            required={required}
            data-star
            data-index-id={indexId} // Necessary for HmdSurvey
            onChange={onChange}/>
          <label htmlFor={key}>{`${v} stars`}</label>
        </Fragment>
      );
    })}
  </div>
);

StarRatingRadio.defaultProps = {
  starRatings: [5, 4, 3, 2, 1],
  name: 'rating',
  onChange: () => (null),
  indexId: null,
  required: false
};

export default StarRatingRadio;
